import { render, staticRenderFns } from "./CustomViewRestrictionEditor.vue?vue&type=template&id=9fdf961c&scoped=true"
import script from "./CustomViewRestrictionEditor.vue?vue&type=script&lang=js"
export * from "./CustomViewRestrictionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdf961c",
  null
  
)

export default component.exports